var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseButton',{attrs:{"type":"button","primary":""},on:{"click":_vm.showCreateRoleDialog}},[_vm._v("Add role")])
}
var staticRenderFns = []

export { render, staticRenderFns }